module.exports = __webpack_public_path__ + "static/media/jp.ae89446a.svg";